import React from 'react';
import PropTypes from 'prop-types';
import { OrderedMap } from 'immutable';

import UserModel from 'models/user';
import Brand from 'models/brand';
import { hasBusinessProfile, BUSINESS_PROFILE_TYPE, BUSINESS_ACCOUNT_TYPE } from 'models/payment-method';

import PaymentMethod from 'components/payment-methods/payment-method';
import BusinessProfileAd from 'components/payment-methods/business-profiles/ad';
import AccountHeadline from 'components/common/account/account-headline';

const propTypes = {
  paymentMethods: PropTypes.instanceOf(OrderedMap).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
  editPaymentMethod: PropTypes.func.isRequired,
  connectPaymentMethod: PropTypes.func.isRequired,
  newPaymentMethod: PropTypes.func.isRequired,
  newBusinessProfile: PropTypes.func.isRequired,
  defaultPaymentMethodId: PropTypes.string,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  defaultPaymentMethodId: null,
};

const PaymentMethods = ({
  user,
  paymentMethods,
  defaultPaymentMethodId,
  setDefaultPaymentMethod,
  deletePaymentMethod,
  editPaymentMethod,
  connectPaymentMethod,
  newPaymentMethod,
  newBusinessProfile,
  brand,
  app,
  trackEvent,
}) => {
  const paymentMethodCards = [];
  paymentMethods.filter(paymentMethod => (
    brand.showBusinessPaymentMethods || ![BUSINESS_ACCOUNT_TYPE, BUSINESS_PROFILE_TYPE].includes(paymentMethod.type)
  )).forEach(paymentMethod => paymentMethodCards.push(
    <PaymentMethod
      user={user}
      paymentMethod={paymentMethod}
      key={`pm-${paymentMethod.id}`}
      setDefaultPaymentMethod={setDefaultPaymentMethod}
      defaultPaymentMethodId={defaultPaymentMethodId}
      deletePaymentMethod={deletePaymentMethod}
      editPaymentMethod={editPaymentMethod}
      connectPaymentMethod={connectPaymentMethod}
      brand={brand}
    />,
  ));

  if (!hasBusinessProfile(paymentMethods) && brand.showBusinessPaymentMethods) {
    paymentMethodCards.push(
      <div className="col-md-4 col-xs-12 business-profile-card">
        <div className="clickable btn-cutout btn-blue btn-boxy text-weight-medium" onClick={newBusinessProfile}>
          <div className="btn-boxy-text h5-sg">
            <span className="iconified-font iconified-briefcase" /> ADD BUSINESS PROFILE
          </div>
          <div className="text-color-light-grey text-weight-book hidden-lte-sm concur-callout">
            <span className="iconified-font iconified-link text-color-light-grey h3-sg" /> Link to Concur or Expensify
          </div>
        </div>
      </div>,
    );
  }
  paymentMethodCards.push(
    <div className="col-md-4 col-xs-12">
      <div className="clickable btn-cutout btn-blue btn-boxy text-weight-medium" onClick={newPaymentMethod}>
        <div className="btn-boxy-text h5-sg">
          <span className="iconified-font iconified-plus" /> ADD PAYMENT METHOD
        </div>
      </div>
    </div>,
  );

  const nodes = [];
  for (let i = 0; i < paymentMethodCards.length; i += 3) {
    nodes.push(<div className="row" key={`pm-row-${i + 1}`}>
      {paymentMethodCards[i]}
      {paymentMethodCards[i + 1]}
      {paymentMethodCards[i + 2]}
    </div>);
  }

  return (
    <div>
      <AccountHeadline brand={brand} headline="MANAGE PAYMENT METHODS" app={app} trackEvent={trackEvent} />
      <BusinessProfileAd paymentMethods={paymentMethods} onClick={newBusinessProfile} brand={brand} />
      <div className="row with-bottom-margin-2x">
        <div className="col-xs-12">
          {nodes}
        </div>
      </div>
    </div>
  );
};

PaymentMethods.propTypes = propTypes;
PaymentMethods.defaultProps = defaultProps;

export default PaymentMethods;
